import _html_handler from "./_html_handler"
import MarkerControl from "./marker_control"
import('../../../../styles/components/map/filter_marker_form.css');


function FilterMarkerForm(options){
    this._container = options.container
    this._filter_options_list = options.filter_options_list
    this.markerControl = undefined
    this._markers = options.markers
    this._submit_button = options.submit_button
    this._clear_button = options.clear_button
    this._on_change_filter = options.on_change_filter
    this._current_filter = {}
    this._title = options.title
    this._show_total_results = options.show_total_results
    this._mapComponent = options.mapComponent
    this._markers_layer_name = options.markers_layer_name
    let _default_filter_option = options.default_filter_option
    let save_filter

    /**
     * Algumas funções e tarefas que devem ser feitas na inicialização do objeto
    */
    function initialize(){
        //adicionando listeners gerais
        setListeners.call(this)
    }
    //chamando as funções de inicialização. Usando 'call' para passar o contexto já que a função é privada. Contexto sendo utilizado como parametro para listerners
    initialize.call(this)

    this.generate = () =>{
        //cria a estrutura base
        this.setContainerContent(_html_handler.generateBaseStructure())

        //adicionar titulo ao formulário caso informado na inicialização
        this.generateTitle()

        //inicializa o MarkerControl
        this.markerControl = new MarkerControl(this._markers,{})

        //cria o select com base nas opções informadas na inicialização do objeto
        $.each(this._filter_options_list, (index, option)=>{
            //cria o select e 'appenda' ao select_container
            _html_handler.appendSelectContent(_html_handler.generateSelect(option, this.markerControl.getOptionFromMarkers(option)))
        })

        //cria uma caixa para setar o filtro para 'default'.
        if(_default_filter_option){
            this.generateDefaultFilterBox()
        }
        
        //gera os botões de form
        this.generateButtons()
        
        //form-controls para selectPicker
        _html_handler.toSelectPicker()
    }

    this.setSelectValue = (dataset_id, values) =>{
        //definindo os valores selecionados da select, mas não sera filtrado
        $('#'+_html_handler._container_id).find(`.form-control[data-id=${dataset_id}]`).selectpicker('val',values)
    }

    this.getCurrentFilter = _ =>{
        return this._current_filter
    }

    this.generateButtons = () =>{
        _html_handler.generateButtons({confirm: this._submit_button, clear: this._clear_button})
    }

    this.setContainerContent = (html) => {
        $(this._container).html(html)
    }

    this.filterMarkers =() =>{
        let obj = {}
        $('#'+_html_handler._container_id).find('.form-control').each((index, option)=>{
            if(option.value){
                obj[option.dataset.id] = $(option).val()
            }
        })
        //set current filter options, apenas para efeito de facilidade no acesso da informação
        this._current_filter = obj
        //filtrando os markers com base nas options. O resultado fica dentro da variavel markerControl._current_markers. Pode ser obtido por markerControl.getCurrentMarkers()
        this.markerControl.filter(obj, false)
    }
    
    this.filter = _ =>{
        //filtrando marcadores
        this.filterMarkers();
            
        //trigger evento 'filtered' ao filtrar os marcadores, retornando a lista de marcadores que passaram nas cláusulas do filtro
        $(".filter-marker-form").trigger("filtered", {markers:this.markerControl.getCurrentMarkers(), options:this._current_filter});
        if(this._show_total_results && hasAnyRule.call(this)){
            //adicionando mensagem de quantidade de markers filtrados
            _html_handler.setMessageContent(_html_handler.generateMessage(this.markerControl.getCurrentMarkers().length))
        } else {
            //limpando mensagem
            _html_handler.setMessageContent('')
        }
    }
    
    this.generateTitle = () =>{
        _html_handler.setTitleContent(_html_handler.generateTitle(this._title.text))
    }

    this.generateDefaultFilterBox = _ =>{
        let el = createElement('div', 'default-filter-option-container')
        let check = createElement('input')
        let label = "<label> Filtro padrão?</label>"
        
        check.type = 'checkbox'
        if(localStorage && localStorage.getItem("sibh_charts_default_filter")){
            //tem filtro pré definido, check = checked
            check.checked = true
            this.setSaveFilter(true)
        }
        $(el).append(check,label)

        $("."+_html_handler._default_filter_container_id).append(el)

        //on change da checkbox
        $(check).on('change', _=>{
            //setando que o filtro deve ser salvo
            this.setSaveFilter(check.checked)
            this.saveFilter()
        })
    }
    
    this.setSaveFilter = boolean =>{
        save_filter = boolean
    }

    this.saveFilter = _ =>{
        if(shouldSave()){
            localStorage.setItem("sibh_charts_default_filter", JSON.stringify(this._current_filter))
        } else {
            localStorage.removeItem("sibh_charts_default_filter")
        }
    }

    /**
     * Adicionando listeners aos objetos do formulário
     * @param {Object} filter_maker_form contexto FilterMarkerForm
     */
    function setListeners(){
        let context = this
        //listeners só serão adicionados caso a opção seja marcada na inicialização do filterMaker
        //verificando a opção de criação do botao submit
        if(this._submit_button && this._submit_button.show){
            
            $(document).on('click', ('.'+_html_handler._button_submit_id), ()=>{
                // console.log('submiting');
                context.filter()
            })
        }
        if(this._clear_button && this._clear_button.show){
            $(document).on('click', ('.'+_html_handler._button_clear_id), ()=>{
                //limpando todas as opções selecionadas dos selects do formulário
                _html_handler.clearAllSelectedOptions()
            })
        }
        //verificando a opção de filtro ao mudar select
        if(this._on_change_filter){
            $(document).on('change', '.filter-marker-form select.form-control', function(){
                context.filter()
            })
        }
    }

    function hasAnyRule(){
        return Object.keys(this._current_filter).length > 0
    }
    function createElement(type,classList){
        let el = document.createElement(type)
        if(classList){
            $(el).addClass(classList)
        }
        return el
    }

    function shouldSave(){
        return save_filter && localStorage
    }
}

export default FilterMarkerForm